
  import React from "react"
  import Component from "/Users/magnan/Devel/catai/toe/src/layouts/index.js"
  import data from "/Users/magnan/Devel/catai/toe/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js